import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=585af2ba&scoped=true&"
import script from "./createUser.vue?vue&type=script&lang=js&"
export * from "./createUser.vue?vue&type=script&lang=js&"
import style0 from "./createUser.vue?vue&type=style&index=0&id=585af2ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../mercari_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585af2ba",
  null
  
)

export default component.exports